import { action } from 'easy-peasy';
import { IActionSetTableCustomizations } from '../types';

const setTableCustomizations: IActionSetTableCustomizations = action((state, { typeId, items }) => {
  state.items[typeId] = items;
});

export default setTableCustomizations;
